import quiz from "./quiz";
import emojiQuiz from "./emoji-quiz";
import pictureQuiz from "./picture-quiz";
import openEnded from "./open-ended";

const exportArray = [openEnded, quiz, pictureQuiz, emojiQuiz];

export default exportArray;
